import { z } from 'zod';

export const dataConstants = {
	SSN: 'ssn',
};

export const testContent = {
	ssn_input_label: 'Social Security number',
	ssn_input_helper:
		'Please include dashes when typing in your social security number. (i.e. 123-45-6789)',
	security_text:
		'We take your security extremely seriously, using industry-standard encryption to protect your data.',
};

export const schema = z.object({
	[dataConstants.SSN]: z.string().regex(/^(?!(000|666|9))\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/, {
		message: 'SSN must be in format of XXX-XX-XXXX',
	}),
});
